export enum StepType {
  APPRAISER = 'appraiser',
  PHOTOSHOOTING = 'photoshooting',
  DOCUMENTS = 'documents',
  AD = 'ad',
  VIEW = 'view',
  BIDDING = 'bidding',
  CONTRACT = 'contract',
  SETTLEMENT = 'settlement',
}

export enum StepStatus {
  NEW = 'new',
  IN_PROGRESS = 'in_progress',
  PENDING = 'pending',
  COMPLETED = 'completed',
  CANCELED = 'canceled',
}
